import { gql } from '@apollo/client'
import { Modal } from '@farol-ds/react'
import { ReactNode } from 'react'

import { useSendViewItemEvent } from '../../hooks/use-send-view-item-event'
import { useModalContext } from '../context'
import { ModalLock_OfferLockBodyFragment } from './__generated__/modal-lock.graphql'

export interface ModalLockProps {
  children: ReactNode
  offerLockBody: ModalLock_OfferLockBodyFragment
}

export function ModalLock({ children, offerLockBody }: ModalLockProps) {
  const { open, setOpen } = useModalContext()
  const { sendViewItemRef } = useSendViewItemEvent({ offerLockBody })

  return (
    <Modal size="md" open={open} onOpenChange={setOpen}>
      <Modal.Content data-testid="modal-lock-content">
        <Modal.IconClose data-testid="modal-lock-icon-close" />
        <Modal.Body data-testid="modal-lock-body" ref={sendViewItemRef}>
          {children}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}

ModalLock.fragments = {
  offerLockBody: gql`
    fragment ModalLock_offerLockBody on OfferLockBody {
      ...UseSendViewItemEvent_offerLockBody
    }

    ${useSendViewItemEvent.fragments.offerLockBody}
  `,
}
